import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Sidebar = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { language } = useSelector((state) => state.language);
    const { userType } = useSelector((state) => state.user);
    const { activeLink } = useSelector((state) => {
        console.log('state', state);
        return state.loader;
    });

    return (
        <aside id="nav-bar" className="nav-sidebar">
            <nav className="w-full h-full flex flex-col">
                <a className="nav_log justify-center" href="#/en/dashboard">
                    <img src="../../assets/images/jogstar-logo.svg" alt="Logo" />
                </a>
                <div className="rounded-2xl w-full h-[calc(100%-72px)] px-3 py-3 flex flex-col">
                    <ul id="accordionSidemenu" className="nav-accordion nav_list flex flex-col gap-0.5 m-0 scrollbar-custom">
                        <li className={"nav_link " + (activeLink === 'dashboard' ? 'active' : '')} onClick={() => navigate(`/${language}/dashboard`)}>
                            <a>
                                <span>
                                    <img alt={t('dashboard')} src="../../assets/images/icons/dashboard-square.svg" />
                                </span>
                                <span className="nav_name">{t('dashboard')}</span>
                            </a>
                        </li>
                        {/* {userType === "coach" && 
                        <li className={"nav_link " + (activeLink === 'stats' ? 'active' : '')} onClick={() => navigate(`/${language}/stats`)}>
                            <a>
                                <span>
                                    <img alt={t('stats')} src="../../assets/images/icons/bar-chart.svg" />
                                </span>
                                <span className="nav_name">{t('stats')}</span>
                            </a>
                        </li>} */}
                        {/* {userType === "coach" && 
                        <li className={"nav_link " + (activeLink === 'luminaires' ? 'active' : '')} onClick={() => navigate(`/${language}/luminaires`)}>
                            <a>
                                <span>
                                    <img alt={t('luminaires')} src="../../assets/images/icons/football-player.svg" />
                                </span>
                                <span className="nav_name">{t('luminaires')}</span>
                            </a>
                        </li>} */}
                        {/* {userType === "coach" && 
                        <li className={"nav_link " + (activeLink === 'results' ? 'active' : '')} onClick={() => navigate(`/${language}/results`)}>
                            <a >
                                <span>
                                    <img alt={t('results')} src="../../assets/images/icons/football-ground.svg" />
                                </span>
                                <span className="nav_name">{t('results')}</span>
                            </a>
                        </li>} */}
                        {/* {userType === "coach" && 
                        <li className={"nav_link " + (activeLink === 'ranking' ? 'active' : '')} onClick={() => navigate(`/${language}/ranking`)}>
                            <a>
                                <span>
                                    <img alt={t('ranking')} src="../../assets/images/icons/football.svg" />
                                </span>
                                <span className="nav_name">{t('ranking')}</span>
                            </a>
                        </li>} */}
                        {userType === "admin" &&
                            <li className={"nav_link " + (activeLink === 'tournaments-events' ? 'active' : '')} onClick={() => navigate(`/${language}/tournaments-events`)}>
                                <a>
                                    <span>
                                        <img alt={t('tournaments-events')} src="../../assets/images/icons/trophy.svg" />
                                    </span>
                                    <span className="nav_name">{t('tournaments-events')}</span>
                                </a>
                            </li>}
                        {userType === "admin" &&
                            <li className={"nav_link " + (activeLink === 'sponsor' ? 'active' : '')} onClick={() => navigate(`/${language}/sponsor`)}>
                                <a>
                                    <span>
                                        <img alt={t('sponsor')} src="../../assets/images/icons/trophy.svg" />
                                    </span>
                                    <span className="nav_name">{t('sponsor')}</span>
                                </a>
                            </li>}
                        {userType === "admin" &&
                            <li className={"nav_link " + (activeLink === 'referee' ? 'active' : '')} onClick={() => navigate(`/${language}/referee`)}>
                                <a>
                                    <span>
                                        <img alt={t('referee')} src="../../assets/images/icons/trophy.svg" />
                                    </span>
                                    <span className="nav_name">{t('referee')}</span>
                                </a>
                            </li>}
                        {userType === "admin" &&
                            <li className={"nav_link " + (activeLink === 'coach' ? 'active' : '')} onClick={() => navigate(`/${language}/coach`)}>
                                <a>
                                    <span>
                                        <img alt={t('coach')} src="../../assets/images/icons/trophy.svg" />
                                    </span>
                                    <span className="nav_name">{t('coach')}</span>
                                </a>
                            </li>}
                        {userType === "admin" && 
                            <li className={"nav_link " + (activeLink === 'user' ? 'active' : '')} onClick={() => navigate(`/${language}/user`)}>
                                <a>
                                    <span>
                                        <img alt={t('user')} src="../../assets/images/icons/user.svg" />
                                    </span>
                                    <span className="nav_name">{t('user')}</span>
                                </a>
                            </li>}
                        {userType === "coach" &&
                            <li className={"nav_link " + (activeLink === 'manage-player' ? 'active' : '')} onClick={() => navigate(`/${language}/manage-player`)}>
                                <a>
                                    <span>
                                        <img alt={t('team-management')} src="../../assets/images/icons/user.svg" />
                                    </span>
                                    <span className="nav_name">{t('manage-player')}</span>
                                </a>
                            </li>}
                        {userType === "coach" &&
                            <li className={"nav_link " + (activeLink === 'team-management' ? 'active' : '')} onClick={() => navigate(`/${language}/team-management`)}>
                                <a>
                                    <span>
                                        <img alt={t('team-management')} src="../../assets/images/icons/team.svg" />
                                    </span>
                                    <span className="nav_name">{t('team-management')}</span>
                                </a>
                            </li>}
                        <li className={"nav_link " + (activeLink === 'settings' ? 'active' : '')} onClick={() => navigate(`/${language}/setting`)}>
                            <a>
                                <span>
                                    <img alt={t('settings')} src="../../assets/images/icons/gear.svg" />
                                </span>
                                <span className="nav_name">{t('settings')}</span>
                            </a>
                        </li>
                    </ul>

                    <div className="admin-box mt-auto dropdown relative md:block hidden">
                        <div className="p-2 pt-8 rounded-xl border border-secondary-500 bg-secondary-600 cursor-pointer relative duration-300">
                            <div className="absolute -top-10 left-0 right-0 text-center">
                                <img src={require("../../assets/images/shoes-ball.png")} alt="" className="max-w-[100px] inline" />
                            </div>
                            <div className="flex flex-col text-center">
                                <p className="font-secondary text-base font-black uppercase text-white">{t('oneTeam')}, {t('oneDream')}</p>
                                <p className="font-secondary text-lg font-black leading-none uppercase bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">
                                    {t('letsDreamTogether')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </aside>
    )
}
export default Sidebar